<template>
  <div class="fxmainbox">
    <div class="fxright" id="aibotbox">
      <div class="contentbox" style="calc(100% - 20px)">

        <div class="content" id="resultbox">

          <div class="zhuibox">
            <!-- <div class="zhuiitem" v-for="(item, i) in zhuilist" :key="i" @click="sendmes(item)">
              <img src="../img/zhuiwenicon.png" />{{ item }}
            </div> -->
            <span v-for="(item, i) in talklist" :key="i">
              <div class="useritem" v-if="item.message.length > 0">
                <div class="userleft"><img src="../../assets/img/znt/talk/logo.png" /></div>
                <div class="userright">
                  <div class="usertext">{{ item.message }}</div>
                </div>
              </div>
              <div class="aiitem">
                <div class="aileft"><img src="../../assets/img/znt/talk/logo.png" /></div>
                <div class="airight">
                  <div class="aitext">

                    <el-button type="text" v-if="item.reply_content.result == '' && !item.reply_content.thinktxt"
                      icon="el-icon-loading">生成中..</el-button>
                    <span v-else>
                      <!-- <div>总结：</div> -->
                      <div class="resultbox"
                        v-if="item.reply_content.thinktxt && item.reply_content.thinktxt.length > 0">
                        <el-collapse v-model="activeNames">
                          <el-collapse-item name="1">
                            <template slot="title">
                              <i class="el-icon-s-opportunity"></i>深度思考过程（点击可折叠）
                            </template>
                            <vue-markdown :source="item.reply_content.thinktxt" class="custom-markdown"></vue-markdown>
                          </el-collapse-item>
                        </el-collapse>

                        <!-- {{ item.reply_content.thinktxt }} -->
                      </div>
                      <div v-if="znttitle" style="margin-bottom: 10px;">{{ znttitle }}</div>
                      <vue-markdown :source="item.reply_content.result" class="custom-markdown"></vue-markdown>
                    </span>
                  </div>
                </div>
              </div>
            </span>
          </div>

        </div>
        <div class="sendbtn">
          <div @click="stopconn" v-if="isconn" class="btnitem stop"><i class="el-icon-video-pause"></i></div>
          <div class="inputbox">
            <input type="text" id="qmess" class="sendinput" placeholder="点我开始智问" />
            <div class="mysenbtn" @click="senmessage"><img src="@/assets/img/znt/talk/send.png" alt=""></div>
          </div>
          <div class="quebox">
            <div class="queitem" @click="sendmes(item)" v-for="item in quelist">{{item}}</div>
          </div>
          <div @click="opensd" :class="issd ? 'btnitem2 btnitemed' : 'btnitem2'">DS-R1</div>
          <div @click="openlw" :class="islw ? 'btnitem2 btnitemed' : 'btnitem2'">联网</div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import qs from 'qs'
import VueMarkdown from 'vue-markdown'
import { baseUrl } from '@/axios/baseUrl'
export default {
  name: '',
  components: {
    VueMarkdown
  },
  data(props) {
    return {
      eventSource: null,
      talklist: [{
        message: '',
        reply_content: {
          result: '你好，关于白草莓数据监控相关的问题都可以问我哦~'
        }
      }],
      showtitle: props.isshowtitle || true,
      activeNames: ['1'],
      querytxt1: props.querytxt || '',
      issd: false,
      islw: false,
      isconn: false,
      quelist: ['昨天大棚内平均气温是多少？',
                '未来3天赣州市天气情况怎么样？',
                '现在大棚内土壤湿度是多少，需要浇水吗？',
                '昨天赣州市的降雨量是多少？']
    }
  },
  props: {
    isshowtitle: { type: Boolean },
    querytxt: { type: String },
    znttitle: { type: String },
  },
  mounted() {
  },
  watch: {
    isshowtitle(n) {
      console.log(n, '对话收到了标题状态')
      this.showtitle = n;
    },
    querytxt(n) {
      console.log(n, '对话收到了消息')
      if (this.talklist.length == 0) {
        this.sendmes(n)
      }

    },

  },
  methods: {
    opensd() {
      this.issd = !this.issd
    },
    sendmes(msg) {
      document.getElementById('qmess').value = msg
      setTimeout(() => {
        this.senmessage()
      }, 200);
    },
    triggerUpload() {
      this.$refs.fxfileInput.click(); // 触发input的点击事件
    },
    senmessage() {
      const message = document.getElementById('qmess').value
      if (message == '' || this.isconn) return;
      this.talklist.push({
        message: message,
        reply_content: {
          result: ''
        }
      })
      const element = document.getElementById('resultbox')
      setTimeout(() => {
        element.scrollTo({
          x: 0,
          top: element.scrollHeight,
          behavior: 'smooth'
        })

        document.getElementById('qmess').value = ''
      }, 300)
      this.connectSever(message);
    },
    openlw() {
      this.islw = !this.islw
    },
    connectSever(message) {
      const that = this;
      const modeltype = this.issd ? 'deepseek-r1:70b' : 'qwen2-72b';
      that.eventSource = new EventSource(`${baseUrl}/queapi/robot_writing/gygpt_chat?query=${message}&robotId=106&modelName=${modeltype}`, {})
      that.isconn = true;
      that.isconn = true;
    that.eventSource.addEventListener('open', (event) => {
        that.isconn = true;
        console.log('连接已建立', JSON.stringify(event))

    })
    let thinkend = 0;
    let returncontent = ''
    let endflag = false
    const lnum = this.talklist.length - 1
    that.eventSource.onmessage = (event) => {
        that.isstop = true;
        // console.log(event.data)
        const data = JSON.parse(event.data)

        // console.log(data)
        if (!data) {
            that.talklist[that.talklist.length - 1].reply_content.result = '正在思考...'
            that.talklist[that.talklist.length - 1].reply_content.thinktxt = ''
            return
        }
        if (that.talklist[that.talklist.length - 1].reply_content.result == '正在思考...') {
            that.talklist[that.talklist.length - 1].reply_content.result = ''
        }
        if (data.id) {
            this.historyid = data.id
            return;
        }

        that.isshowcw = true

        if (data.answer == '[DONE]') {
            that.talklist[that.talklist.length - 1].reply_content.relatedquestion = data.relatedquestion;
            return;
        }
        if (data.id) {
            this.talkguanlianid = data.id
            return;
        }

        // .replace('<think>', '<div style="color:#6c6c6c;background-color: #f2f2f2;padding:10px">').replace('</think>', '</div>')
        if (data.answer.includes('</think>')) {
            thinkend = 2
            return;
        }
        if (data.answer.includes('<think>')) {
            thinkend = 1
            return;
        }
        // if (!this.thinkend && this.issd) {
        //   this.thinkresult = this.thinkresult + data.answer;
        //   return
        // }

        // console.log(thinkend, that.talklist[that.talklist.length - 1].reply_content.thinktxt)
        that.talklist[that.talklist.length - 1].reply_content.imagereplys = data.imagereplys ? data.imagereplys : data.imagereply ? [data.imagereply] : null
        if (thinkend == 1 && this.issd) {
            Vue.set(that.talklist[that.talklist.length - 1].reply_content, 'thinktxt', (that.talklist[that.talklist.length - 1].reply_content.thinktxt + data.answer).replace('undefined', ''))
            // that.talklist[that.talklist.length - 1].reply_content.thinktxt = that.talklist[that.talklist.length - 1].reply_content.thinktxt + data.answer;
        } else {
            that.talklist[that.talklist.length - 1].reply_content.result = that.talklist[that.talklist.length - 1].reply_content.result + data.answer;
        }
        // console.log(that.talklist[lnum].reply_content.thinktxt)
        this.$forceUpdate();
        if (that.talklist[lnum].reply_content.result.length % 10 == 0 || event.data.includes('，')) {
            that.$nextTick(() => {
                const element = document.getElementById('resultbox')
                element.scrollTo({
                    x: 0,
                    top: Number.MAX_SAFE_INTEGER,
                    behavior: 'smooth'
                })
            })
        }
      }
      that.eventSource.onerror = (event) => {
        // console.log('returncontent', JSON.parse(returncontent.replace(/&nbsp;/g, ' ')));
        // that.talklist[lnum].reply_content.returncontent = JSON.parse(returncontent.replace(/&nbsp;/g, ' '))
        console.log(event)
        that.isconn = false;
        this.$emit('endtalk')

        that.eventSource.close()
        that.eventSource = null
        that.$nextTick(() => {
          const element = document.getElementById('resultbox')
          element.scrollTo({
            x: 0,
            top: Number.MAX_SAFE_INTEGER,
            behavior: 'smooth'
          })
        })
      }
    },
    stopconn() {
      this.eventSource.close()
      this.eventSource = null
      this.isconn = false;
    },

    async copy() {



    },
    backklg() {
      console.log('回去')
      this.eventSource && this.eventSource.close()
      this.$emit('back', '')
    },


  }
}
</script>
<style lang='less' scoped>
.fxmainbox {
  width: 100%;
  font-family: 'pingfang', 'Source Han Sans CN', Avenir, Helvetica, Arial, sans-serif !important;
  display: flex;
  height: 100%;
  position: relative;


  .fxright {
    width: calc(100% - 0px);

    .allspbox {
      position: absolute;
      right: 30px;
      top: -85px;
      width: 60px;
      height: 60px;
      z-index: 2;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 6px;

      img {
        width: 30px;
      }
    }

    .titlebox {
      padding: 20px;
      font-weight: bold;
      display: flex;
      flex-wrap: wrap;


      .title {
        width: 100%;
        font-family: PangMenZhengDao;
        font-size: 24px;
        background-image: linear-gradient(to right, #0081FF, #99BBEB);
        -webkit-background-clip: text;
        color: transparent;
        /* 使文字颜色透明，以便看到背景渐变 */
      }

      .queitem {
        background-color: #F5F8FF;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        color: #6F7285;
        margin-top: 20px;
        padding: 10px 30px;
        font-size: 14px;
        cursor: pointer;
      }

      .queitem:hover {
        background-color: #038AFC;
        color: white;
      }
    }

    .rtop {
      display: flex;
      justify-content: space-between;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 6px;
      padding: 10px;

      .rtopbox {
        width: 100%;

        display: flex;
        padding: 0;


        .rtopitem {
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 15px;
          cursor: pointer;
        }

        .rted {
          color: #0064E2;
          border-bottom: 2px solid #0064E2;
        }
      }

      .pptright {
        border-left: 1px solid #EAEBED;
        padding-left: 20px;

        img {
          width: 40px;
        }
      }
    }

    .contentbox {
      width: 100%;
      height: calc(100% - 0px);
      position: relative;
      padding-top: 15px;

      .contenttop {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: 20px;
          font-weight: bold;
        }

        .clickbox {
          display: flex;
        }
      }

      .content {
        width: 100%;
        height: calc(100% - 80px);
        overflow-y: auto;

        .custom-markdown {
          width: 100%;
          height: 100%;
          font-size: 14px;
          overflow-y: auto;
          word-break: break-all;
        }

        .custom-markdown {
          /deep/ .table {
            border-collapse: collapse;
            border-spacing: 0;
          }

          /deep/ .table {
            border-top: 1px solid #333;
            border-left: 1px solid #333;
          }

          /deep/ .table tbody tr td,
          /deep/ .table thead tr th {
            border-right: 1px solid #333;
            border-bottom: 1px solid #333;
            padding: 6px;
          }
        }

        .xmindbox {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-start;

          img {
            width: 100%;
          }
        }

        .zhuibox {
          .zhuiitem {
            display: flex;
            align-items: center;
            padding: 10px;
            margin: 10px 0;
            background-color: #1C223610;
            font-size: 18px;
            border-radius: 10px;
            cursor: pointer;

            img {
              width: 20px;
              margin-right: 12px;
            }
          }
        }

        .aiitem {
          display: flex;
          width: calc(100% + 0px);
          position: relative;
          margin: 10px 0;
          .aileft{
            img{
              width: 35px;
              margin-right: 6px;
            }
          }

          .airight {
            min-width: 180px;
            max-width: calc(100% - 50px);
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 10px;
            text-align: left;
            margin-bottom: 10px;
            background: #fff;
            border-radius: 0px 12px 12px 12px;
            position: relative;



            .name {
              font-size: 18px;
              color: #333;
              margin-bottom: 10px;

              span {
                font-size: 12px;
                background: #F8F8F9;
                border-radius: 6px;
                padding: 4px 8px;
                margin-left: 10px;
              }
            }

            .aitext {
              // width: 500px;
              width: 100%;
              color: #333;
              font-size: 14px;

              .loadinggif {
                height: 52px;

                img {
                  height: 52px;
                }
              }

              /deep/ .el-collapse-item__header,
              /deep/ .el-collapse-item__wrap,
              /deep/ .el-collapse-item__content {
                background-color: #f2f2f2 !important;
                font-size: 14px;
                padding-bottom: 0;

              }

              /deep/ .el-collapse-item__header {
                color: #409eff
              }

              /deep/ .el-collapse-item__content {
                color: #8b8b8b !important;
                border-left: 1px solid #bdbdbd;
                padding-left: 10px;
              }

              .resultbox {
                color: #262626;
                background-color: #C5D9F0;
                padding: 10px;
                margin-bottom: 20px;
                border-radius: 12px;
              }

              .custom-markdown code,
              .custom-markdown /deep/ pre,
              .custom-markdown pre code {
                white-space: break-spaces;
                word-break: break-all;
                font-size: 14px;
                /* 换行 */
              }


            }


          }
        }

        .useritem {
          position: relative;
          color: white;
          width: calc(100% - 10px);
          display: flex;
          justify-content: flex-start;
          flex-direction: row-reverse;

          .userleft{
            margin-top: 6px;
            img{
              width: 35px;
              margin-left: 6px;
            }
          }

          .userright {
            text-align: left;
            float: right;
            margin: 10px 0;
            max-width: 800px;
            margin-left: 40px;

            .usertext {
              background: linear-gradient( 180deg, #A3CD9A 0%, #609217 100%);
              color: #fff;
              border-radius: 12px 0px 12px 12px;
              font-size: 14px;
              line-height: 22px;
              padding: 6px 20px;
              white-space: pre-wrap;
            }
          }
        }


      }

      .sendbtn {
        width: calc(100% + 25px);
        position: absolute;
        bottom: -5px;
        left: -12.5px;
        height: 50px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        background: #fff;

        .btnitem {
          background: #F3F4F2;
          color: #333;
          /* padding: 4px 10px; */
          width: 33px;
          height: 30px;
          text-align: center;
          border-radius: 10px;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 15px;
          }
        }
        .stop{
          font-size: 20px;
          color: #fff;
          background-color: #fd5127;
        }

        .btnitem2{
          background: #F3F4F2;
          color: #333;
          /* padding: 4px 10px; */
          width: 63px;
          margin-left: 10px;
          height: 30px;
          text-align: center;
          border-radius: 10px;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 15px;
            margin-left: 5px;
          }
        }

        .quebox {
          padding: 4px;
          font-size: 14px;
          cursor: pointer;
          position: absolute;
          left: 0px;
          top: -40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow-x: auto;
          width: 100%;
          /* 隐藏垂直滚动条（Chrome/Safari/Edge） */
          &::-webkit-scrollbar {
            height: 0px; /* 调整水平滚动条高度 */
            width: 0;    /* 隐藏垂直滚动条 */
          }
          
          &::-webkit-scrollbar-track {
            background: transparent; /* 滚动条轨道透明 */
          }
          
          &::-webkit-scrollbar-thumb {
            background-color: #ccc; /* 滚动条颜色 */
            border-radius: 3px;     /* 滚动条圆角 */
          }
          .queitem{
            background-color: #fff;
            color: #609217;
            border-radius: 8px;
            padding: 6px 10px;
            margin-right: 10px;
            text-overflow: ellipsis;
            text-wrap: nowrap;
          }
        }

        .btnitemed {
          background: #6DAF0F;
          color: #fff;
        }

        .inputbox{
          width: calc(100% - 150px);
          display: flex;
          position: relative;
          .sendinput {
            width: 100%;
            height: 32px;
            font-size: 14px;
            margin-left: 10px;
            color: #333;
            outline: none;
            border: none;
            font-family: 'pingfang', 'Source Han Sans CN', Avenir, Helvetica, Arial, sans-serif !important;
            resize: none;
            background-color: #F3F4F2;
            white-space: pre-wrap;
            padding-left: 10px;
            border-radius: 10px;
          }
          .mysenbtn {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: absolute;
            right: 5px;
            top: 2px;
  
            img {
              width: 18px;
              height: 18px;
            }
          }
        }
        

        .tipbox {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: rgba(111, 114, 133, 0.5);
          position: absolute;
          right: 0;
          top: -35px;
        }

        
      }
    }

  }

}

.custom-markdown code,
.custom-markdown p,
.custom-markdown pre,
.custom-markdown pre code {
  white-space: break-spaces;
  word-break: break-all;
  /* 换行 */
}

/deep/ .custom-markdown p,
/deep/ .custom-markdown ol,
/deep/ .custom-markdown li {
  line-height: 22px;
}

/deep/ .custom-markdown {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 10px 0;
  }
}
</style>
